import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { RoleListCustomerCell } from './role-list-customer.cell';
import { RoleListCustomerHeader } from './role-list-customer.header';

export const RoleListCustomerColumn: IdentifiedColumnDef<
  GatewayRoleModel,
  GatewayRoleModel['customer']
> = {
  enableSorting: false,
  header: RoleListCustomerHeader,
  cell: RoleListCustomerCell,
};
